import DOMPurify from 'dompurify';

// Use this for any HTML from the database before passing it to dangerouslySetInnerHTML.
// It keeps formatting (bold, lists, links, images) but strips scripts and event handlers.
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');

// Strip HTML tags, decode entities, collapse whitespace, then trim to a length
export const plainText = (html, max) => {
    const withoutTags = (html || '').replace(/<[^>]+>/g, ' ');
    const el = document.createElement('textarea');
    el.innerHTML = withoutTags; // decodes entities like &amp; (textarea content is never parsed as HTML)
    const text = el.value.replace(/\s+/g, ' ').trim();
    return text.length <= max ? text : text.slice(0, max).trimEnd() + '...';
};
